import { useTranslation } from 'react-i18next';
import { CheckCircle2, Lock, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { trackFunnelEvent } from '@/utils/tracking';

const API = '/api';

export default function PricingCards({ reportId }) {
  const { t } = useTranslation();

  const handleCheckout = async () => {
    // Macro Funnel Completion Sprint (Feb 2026) — canonical report CTA event,
    // emitted ALONGSIDE the existing `payment_clicked` for backwards-compat.
    // Distinct cta_type/cta_label allow downstream to separate Starter Kit /
    // monitoring / checkout CTAs without parsing free-form labels.
    trackFunnelEvent('report_cta_clicked', {
      report_id: reportId,
      meta: {
        cta_type: 'unlock_full_report',
        cta_label: 'volledig_bespaarplan',
        report_type: 'energy_control',
        destination: 'stripe_checkout',
      },
    });
    trackFunnelEvent('payment_clicked', { report_id: reportId, plan: 'volledig_bespaarplan' });
    if (window.pwTrack) window.pwTrack('checkout_start', { report_id: reportId, value: 59, currency: 'EUR' });
    try {
      const response = await axios.post(`${API}/payments/checkout`, {
        plan_id: 'volledig_bespaarplan',
        report_id: reportId,
      });
      if (response.data.url) {
        window.location.href = response.data.url;
      }
    } catch {
      toast.error(t('payment.error'));
    }
  };

  const features = [
    t('pricing.feature1'),
    t('pricing.feature2'),
    t('pricing.feature3'),
    t('pricing.feature4'),
    t('pricing.feature5'),
    t('pricing.feature6'),
  ];

  return (
    <div className="mt-10" data-testid="pricing-cards">
      <div className="max-w-xl mx-auto bg-white rounded-2xl border-2 border-primary shadow-lg p-8" data-testid="plan-card-volledig_bespaarplan">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-medium text-primary mb-2" style={{ fontFamily: 'Outfit' }}>
            {t('payment.unlockTitle')}
          </h2>
          <div className="text-4xl font-light text-primary mb-1" style={{ fontFamily: 'Outfit' }}>€59</div>
          <p className="text-xs text-muted-foreground">{t('payment.oneTime')}</p>
        </div>

        <p className="text-sm text-foreground text-center mb-6 leading-relaxed">
          {t('payment.unlockCTA')}
        </p>

        <ul className="space-y-2.5 mb-8">
          {features.map((f, i) => (
            <li key={i} className="flex items-start gap-2.5">
              <CheckCircle2 className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
              <span className="text-sm text-foreground">{f}</span>
            </li>
          ))}
        </ul>

        <button
          onClick={handleCheckout}
          className="w-full py-3.5 btn-primary text-base rounded-lg font-medium flex items-center justify-center gap-2"
          data-testid="checkout-volledig_bespaarplan-btn"
        >
          <Lock className="w-4 h-4" />
          {t('payment.unlockBtn')}
          <ArrowRight className="w-4 h-4" />
        </button>

        <p className="text-[10px] text-muted-foreground text-center mt-3">
          {t('payment.methods', 'iDEAL · Creditcard · Bancontact')}
        </p>
      </div>

      {/* Quote-route alternative — does not replace the paid report */}
      <p className="text-xs text-muted-foreground text-center mt-4 max-w-xl mx-auto" data-testid="quote-alternative-line">
        {t('payment.quoteAlternative')}
      </p>
    </div>
  );
}
